import Dispatcher from "theme/modules/Router/Dispatcher";

export default Dispatcher;
